import React from 'react'
import { ThemeProvider } from '@mui/material'
import { theme } from 'utils/theme'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { AuthenticatedUserProvider } from './UserContext'
import { AlertProvider } from './AlertContext'
import { FunModeProvider } from './FunModeContext'

const queryClient = new QueryClient()

const AppProvider: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <FunModeProvider>
          <AuthenticatedUserProvider>
            <AlertProvider>{children}</AlertProvider>
          </AuthenticatedUserProvider>
        </FunModeProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}

export default AppProvider
